import { STORYDOC_VARIABLES } from "@/features/dynamic-variables/data/storydoc-variables";
import type { KnownVariable } from "./collect-story-variables";

/**
 * The predefined Storydoc catalog (`STORYDOC_VARIABLES`) is the same list the
 * in-editor picker offers, so any of its tokens can appear in published
 * content. Map it into the `KnownVariable` shape so the publish-time collect
 * resolves each token to its real `type` (e.g. `color`, `select`, `media`)
 * instead of synthesizing a generic `input`. Without this, a predefined
 * variable that isn't also in the legacy FAST_VERSION_VARIABLES / account
 * lists loses its type on publish.
 */
export const STORYDOC_KNOWN_VARIABLES: KnownVariable[] = STORYDOC_VARIABLES.map(
  (sv) => ({
    variable: {
      name: sv.key,
      type: sv.type,
      title: sv.label,
      default: "",
      tip: "",
      validation: { required: false },
    },
  }),
);
